module.exports = __webpack_public_path__ + "img/queue_music.0a12750b.svg";